"use strict";import{tag as e}from"../custom-tag.js";export function warningIcon({height:a=16,width:r=16,hidden:t=!1,title:l="Warning"}={}){return e`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width=${r}
      height=${a}
      fill="currentColor"
      viewBox="0 0 24 24"
      aria-hidden="${t?"true":"false"}"
      role="img"
      aria-label="${l}"
    >
      <mask
        id="warning_svg__mask0_6875_6496"
        width="20"
        height="20"
        x="2"
        y="2"
        maskUnits="userSpaceOnUse"
        style="mask-type:alpha"
      >
        <path
          fill="currentColor"
          d="M12 3.552a.64.64 0 0 1 .578.368l8.267 15.312a.82.82 0 0 1 0 .81.65.65 0 0 1-.558.336H3.734a.65.65 0 0 1-.558-.336.82.82 0 0 1 0-.81L11.474 3.92A.64.64 0 0 1 12 3.552M12 2.5a1.7 1.7 0 0 0-1.504.915L2.23 18.727a1.82 1.82 0 0 0 1.504 2.703h16.532a1.82 1.82 0 0 0 1.504-2.703L13.504 3.415A1.7 1.7 0 0 0 12 2.5"
        />
        <path
          fill="currentColor"
          d="M12.527 8.81h-1.052v6.31h1.052zm-.001 8.413h-1.052v1.052h1.052z"
        />
      </mask>
      <g mask="url(#warning_svg__mask0_6875_6496)">
        <path fill="currentColor" d="M24 0H0v24h24z" />
      </g>
    </svg>
  `}
//# sourceMappingURL=warning.js.map
